import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteTraineesBySectorRequest: ['response'],
    deleteTraineesBySectorSuccess: ['response'],
    deleteTraineesBySectorFailure: ['error'],
})

export const deleteTraineesBySectorTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deleteTraineesBySectorRequest = state => state.merge({ success: null })

const deleteTraineesBySectorSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteTraineesBySectorFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_TRAINEES_BY_SECTOR_REQUEST]: deleteTraineesBySectorRequest,
    [Types.DELETE_TRAINEES_BY_SECTOR_SUCCESS]: deleteTraineesBySectorSuccess,
    [Types.DELETE_TRAINEES_BY_SECTOR_FAILURE]: deleteTraineesBySectorFailure,
})
